export const preferredTeam = {
  header: 'Choose Your Preferred Team',
  availableList: {
    header: 'Wonoloers and Teams',
    teams: {
      empty: 'No teams found',
    },
    wonoloers: {
      empty: 'No Wonoloers found',
    },
  },
  selectedList: {
    header: 'Preferred Team',
  },
  closedPreferred: {
    preferredTeamOnly: 'Preferred Team Only',
    helperText: 'Use only Wonoloers from your Preferred Team. Exclude other Wonoloers.',
    hint: 'Only Wonoloers in your preferred team may view and accept this job.',
    warning: 'Closed Preferred limits the number of Wonoloers that see this job request and may hurt your fill rate.',
    label: 'Preferred team only',
  },
  buttons: {
    submit: 'Confirm Team',
    belowMinimumSubmit: 'Select at least %minimum% %wonoloers%',

  },
  alerts: {
    belowMinimum: 'Select at least %minimum% %wonoloers%. To maximize fill rate, add %idealPreferredWonoloerCount% members to your Closed Preferred team.',
    belowIdeal: 'To maximize fill rate, add %idealPreferredWonoloerCount% members to your Closed Preferred team.',
    ideal: 'You have selected a number of Wonoloers that will maximize the fill rate of this job posting.',
  }
};

